import { WriteRepository } from './WriteRepository';

function throwNotImplemented(operation, path) {
  const location = path ? ` (${path})` : '';
  throw new Error(`API write repository does not implement ${operation}${location}`);
}

export class HttpApiWriteRepository extends WriteRepository {
  async patchDoc(path) {
    throwNotImplemented('patchDoc', path);
  }

  async setDoc(path) {
    throwNotImplemented('setDoc', path);
  }

  async createDoc(collectionPath) {
    throwNotImplemented('createDoc', collectionPath);
  }

  async deleteDoc(path) {
    throwNotImplemented('deleteDoc', path);
  }
}
